import MobileSubmitViewContainer from "./Containers/MobileSubmitViewContainer";
export default MobileSubmitViewContainer;
